// @flow
import React from 'react';
import {
  Button,
  ButtonGroup,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  RadioGroup,
  TextField,
  Typography,
  makeStyles,
} from '@material-ui/core';
import {Add, Remove} from '@material-ui/icons';
import {UseFormRegister, FieldValues, UseFormSetValue} from 'react-hook-form';
import {colors} from '../../../../../assets/styles/colors';

import {DAYS} from '../../constants/allowed-inputs';

import type {CheckoutInput} from '../../../../../entities';
import type {Theme} from '@material-ui/core';
type Props = {
  checkoutInput?: CheckoutInput,
  register: UseFormRegister<FieldValues>,
  setValue: UseFormSetValue<FieldValues>,
  errors: {[key: string]: any},
  availableDays: string[],
  setAvailableDays: (string[] | ((string[]) => string[])) => void,
  enabledMinDays: boolean,
  setEnabledMinDays: (boolean | (boolean => boolean)) => void,
  getValues: (name: string) => any,
};

const useStyles = makeStyles((theme: Theme) => ({
  inputWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  text: {
    fontWeight: 500,
    fontSize: 14,
    color: colors.grey900,
  },
  greyText: {
    fontWeight: 400,
    fontSize: 14,
    color: colors.grey700,
  },
  wrap: {
    width: '100%',
  },
  iconButton: {
    padding: theme.spacing(1),
    background: `${colors.purple3}!important`,
  },
  icon: {
    color: '#FFFFFF',
  },
  radioGroup: {
    width: '100%',
  },
  divider: {
    margin: theme.spacing(1, 0),
  },
  actionButton: {
    width: '5rem',
  },
  textInput: {
    textAlign: 'center',
  },
  error: {color: colors.error, fontSize: 14},
}));

export default function CalendarForm(props: Props) {
  const {
    checkoutInput,
    register,
    errors,
    setValue,
    availableDays,
    setAvailableDays,
    enabledMinDays,
    setEnabledMinDays,
    getValues,
  } = props;
  const classes = useStyles();

  const onSelectDay = e => {
    e.stopPropagation();
    const value = e.target.value;
    if (availableDays.includes(value)) {
      setAvailableDays(ps => ps.filter(el => el !== value));
    } else setAvailableDays(ps => [...ps, value]);
  };

  const handleChangeDays = (value: number) => {
    setValue('minDays', Number(getValues('minDays')) + value);
  };

  return (
    <>
      <Grid item xs={12}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography className={classes.text} gutterBottom>
              Días habilitados
            </Typography>
            <Typography className={classes.greyText} gutterBottom>
              Configura los días que tus compradores pueden seleccionar en el
              calendario
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <RadioGroup className={classes.radioGroup} name="inputType">
              <Grid container style={{width: '100%'}}>
                {DAYS.map(c => (
                  <Grid item xs={6} md={3} key={c.name}>
                    <FormControlLabel
                      name={c.name}
                      label={
                        <Typography className={classes.text}>
                          {c.name}
                        </Typography>
                      }
                      value={c.value}
                      control={
                        <Checkbox
                          color="primary"
                          checked={availableDays.includes(c.value)}
                          onChange={onSelectDay}
                        />
                      }
                    />
                  </Grid>
                ))}
              </Grid>
            </RadioGroup>
          </Grid>
        </Grid>
      </Grid>
      <Divider className={classes.divider} />
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <FormControlLabel
                  label={
                    <Typography className={classes.text}>
                      Definir mínimo de días de anticipación para agendar
                    </Typography>
                  }
                  control={
                    <Checkbox
                      checked={enabledMinDays}
                      onChange={e => setEnabledMinDays(e.target.checked)}
                      color="primary"
                    />
                  }
                />
              </Grid>
              {enabledMinDays && (
                <>
                  <Grid item xs={12}>
                    <ButtonGroup size="small" fullWidth>
                      <Button
                        size="small"
                        className={classes.actionButton}
                        onClick={() => handleChangeDays(-1)}
                        // disabled={isSaving}
                      >
                        <Remove fontSize="small" />
                      </Button>
                      <TextField
                        name="minDays"
                        inputProps={{className: classes.textInput}}
                        defaultValue={checkoutInput?.schema?.min_days_to_select}
                        inputRef={register({
                          required: 'Cantidad incorrecta',
                          pattern: {
                            value: /^[0-9]+([.][0-9]+)?$/i,
                            message: 'Cantidad incorrecta',
                          },
                          min: {
                            value: 0,
                            message: 'Cantidad incorrecta',
                          },
                        })}
                        type="number"
                        error={!!errors.minDays}
                        step="1"
                      />
                      <Button
                        size="small"
                        className={classes.actionButton}
                        onClick={() => handleChangeDays(1)}
                        // disabled={isSaving}
                      >
                        <Add fontSize="small" />
                      </Button>
                    </ButtonGroup>
                  </Grid>
                  {!!errors.minDays && (
                    <Grid item xs={12}>
                      <Typography className={classes.error}>
                        {errors.minDays.message}
                      </Typography>
                    </Grid>
                  )}
                </>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
